import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import FinanceCoursePage from "./pages/FinanceCoursePage";
import FundingPage from "./pages/FundingPage";
import FundingApplyPage from "./pages/FundingApplyPage";
import AboutPage from "./pages/AboutPage";
import FoundersPage from "./pages/FoundersPage";
import WelcomePage from "./pages/WelcomePage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ChurchHubPage from "./pages/ChurchHubPage";
import MelanieChat from "./components/MelanieChat";

const ScrollHandler = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollHandler />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/finance-course" element={<FinanceCoursePage />} />
            <Route path="/funding" element={<FundingPage />} />
            <Route path="/apply" element={<FundingApplyPage />} />
            <Route path="/founders" element={<FoundersPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/c/:slug" element={<ChurchHubPage />} />
          </Routes>
          <MelanieChat />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
